import { combineReducers } from 'redux';
import payTypesReducer from './modules/payTypes/reducer';
import catalogReducer from './modules/catalog/reducer';
import userReducer from './modules/user/reducer';
import popupReducer from './modules/popup';
import cityReducer from './modules/city/reducer';
import sailplayReducer from './modules/sailplay/reducer';
import bannerReducer from './modules/banner/reducer';
import intlReducer from './modules/intl/reducer';
import locationReducer from './modules/location';
import cartReducer from './modules/cart/reducer';
import restaurantReducer from './modules/restaurant/reducer';
import orderReducer from './modules/order/reducer';
import feedbackReducer from './modules/feedback/reducer';
import stockReducer from './modules/stock/reducer';
import cardReducer from './modules/card/reducer';
import payuCardReducer from './modules/payuCard/reducer';
import halvesReducer from './modules/halves/reducer';
import addressReducer from './modules/address/reducer';
import freeSaucesReducer from './modules/freeSauces/reducer';
import constructorReducer from './modules/constructor/reducer';
import uiReducer from './modules/ui/reducer';
import modalReducer from './modules/modal/reducer';
import pageReducer from './modules/page/reducer';
import comboboxReducer from './modules/combobox/reducer';
import errorsReducer from './modules/errors/reducer';
import modalConfirmReducer from './modules/modalConfirm/reducer';
import responsiveReducer from './modules/responsive/reducer';
import promoReducer from "./modules/promo/reducer";

export default combineReducers({
  payTypes: payTypesReducer,
  catalog: catalogReducer,
  user: userReducer,
  popup: popupReducer,
  city: cityReducer,
  banner: bannerReducer,
  intl: intlReducer,
  location: locationReducer,
  cart: cartReducer,
  restaurant: restaurantReducer,
  order: orderReducer,
  feedback: feedbackReducer,
  stock: stockReducer,
  card: cardReducer,
  payuCard: payuCardReducer,
  halves: halvesReducer,
  address: addressReducer,
  sailplay: sailplayReducer,
  freeSauces: freeSaucesReducer,
  ui: uiReducer,
  pizzaConstructor: constructorReducer,
  responsive: responsiveReducer,
  modal: modalReducer,
  page: pageReducer,
  combobox: comboboxReducer,
  errors: errorsReducer,
  modalConfirm: modalConfirmReducer,
  promo: promoReducer,
});
